(() => {
  'use strict';
  const rootUrl = window.Shopify?.routes?.root || '/';
  const route = path => `${rootUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  let data = {products: [], collections: [], links: {}};
  try { data = JSON.parse(document.getElementById('hsb-catalog-data')?.textContent || '{}'); } catch { /* Native Liquid remains usable when supplementary metadata is unavailable. */ }
  const products = Array.isArray(data.products) ? data.products : [];
  const byHandle = handle => products.find(product => product.handle === handle);
  const visible = product => Boolean(product && product.handle !== 'spa-do-pes-chao' && (typeof product.catalog_visible === 'boolean' ? product.catalog_visible : product.status === 'ACTIVE'));
  const consultationOnly = product => product?.consultation_only === true || product?.status !== 'ACTIVE';
  const variantsOf = product => Array.isArray(product?.variants) ? product.variants : [];
  const stringsOf = values => Array.isArray(values) ? values.filter(value => typeof value === 'string' && value.trim()) : [];
  const currency = window.Shopify?.currency?.active || 'BRL';
  const money = cents => new Intl.NumberFormat('pt-BR', {style: 'currency', currency}).format(cents / 100);
  const referenceMoney = value => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value);
  const cashPriceLabel = (product, price) => `${price}${product.price_at_cash ? ' à vista' : ''}`;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-BR').replace(/[^a-z0-9]+/g, ' ').trim();
  const node = (tag, className, text) => {
    const result = document.createElement(tag);
    if (className) result.className = className;
    if (text !== undefined) result.textContent = String(text);
    return result;
  };
  const safeUrl = value => {
    try { const url = new URL(value, window.location.origin); return ['https:', 'http:'].includes(url.protocol) && (url.origin === window.location.origin || url.protocol === 'https:') ? url.href : null; } catch { return null; }
  };
  const link = (text, href, className = '') => {
    const result = node('a', className, text);
    result.href = href;
    if (/^https:\/\/(?:wa\.me|pay\.hotmart\.com)\//.test(href)) { result.target = '_blank'; result.rel = 'noopener noreferrer'; }
    return result;
  };
  const productUrl = product => consultationOnly(product)
    ? `${route('collections/equipamentos')}?view=hsb-modelo-${encodeURIComponent(product.handle)}`
    : route(`products/${encodeURIComponent(product.handle)}`);
  const whatsapp = () => safeUrl(data.links?.whatsapp) || 'https://wa.me/5511916084365';
  const imageFor = (product, className, eager = false) => {
    const src = safeUrl(product.image);
    if (!src) return node('div', `${className} catalog-image-placeholder`, 'Conheça os detalhes do modelo.');
    const image = node('img', className);
    image.src = src;
    image.alt = `${product.title} — fotografia selecionada do produto`;
    image.width = 900;
    image.height = 1000;
    image.loading = eager ? 'eager' : 'lazy';
    image.decoding = 'async';
    if (eager) image.fetchPriority = 'high';
    return image;
  };
  const liveCache = new Map();
  const loadLive = product => {
    if (!visible(product) || consultationOnly(product)) return Promise.resolve(null);
    if (!liveCache.has(product.handle)) liveCache.set(product.handle, fetch(route(`products/${encodeURIComponent(product.handle)}.js`), {credentials: 'same-origin', headers: {Accept: 'application/json'}})
      .then(response => response.ok ? response.json() : null)
      .then(live => live?.handle === product.handle && Array.isArray(live.variants) ? live : null)
      .catch(() => null));
    return liveCache.get(product.handle);
  };
  const referencePrice = product => {
    if (product.price_on_request && !product.price_at_cash) return 'Preço sob consulta';
    const prices = variantsOf(product).map(variant => variant.price).filter(price => typeof price === 'number' && Number.isFinite(price) && price >= 0);
    if (!prices.length) return 'Consulte o preço';
    return cashPriceLabel(product, `${new Set(prices).size > 1 ? 'A partir de ' : ''}${referenceMoney(Math.min(...prices))}`);
  };
  const livePrice = (product, live) => product.price_on_request && !product.price_at_cash ? 'Preço sob consulta' : live && Number.isFinite(live.price_min) ? cashPriceLabel(product, `${live.price_min !== live.price_max ? 'A partir de ' : ''}${money(live.price_min)}`) : live && Number.isFinite(live.price) ? cashPriceLabel(product, money(live.price)) : 'Consulte o preço na página do produto';
  const installmentSimulations = {
    "cuba-de-marmore-1": {
      "cashCents": 1499000,
      "installment": "1.082,53",
      "total": "19.485,50"
    },
    "cuba-de-fibra": {
      "cashCents": 499000,
      "installment": "360,36",
      "total": "6.486,50"
    },
    "cuba-anatomica-de-fibra": {
      "cashCents": 499000,
      "installment": "360,36",
      "total": "6.486,50"
    },
    "cuba-de-marmore": {
      "cashCents": 899000,
      "installment": "649,23",
      "total": "11.686,10"
    },
    "maca-completa-com-cuba-de-fibra": {
      "cashCents": 699000,
      "installment": "504,79",
      "total": "9.086,30"
    },
    "maca-completa-com-cuba-de-fibra-anatomica": {
      "cashCents": 699000,
      "installment": "504,79",
      "total": "9.086,30"
    },
    "maca-completa-com-cuba-de-marmore": {
      "cashCents": 1099000,
      "installment": "793,66",
      "total": "14.285,90"
    },
    "maca-completa-com-cuba-de-marmore-translucida": {
      "cashCents": 1799000,
      "installment": "1.299,18",
      "total": "23.385,20"
    },
    "maca-spa-dos-pes-com-cuba-de-fibra-spa-do-pes": {
      "cashCents": 898000,
      "installment": "648,51",
      "total": "11.673,10"
    }
  };
  const genericInstallmentText = 'Até 18x no cartão pelo Mercado Pago. Confira parcelas, total e disponibilidade no checkout.';
  const installmentNoteText = (product, cashCents, quantity = 1) => {
    const simulation = installmentSimulations[product?.handle];
    if (product?.kind !== 'equipamento' || !visible(product) || product.price_on_request && !product.price_at_cash || currency !== 'BRL' || quantity !== 1 || !Number.isInteger(cashCents) || cashCents !== simulation?.cashCents) return genericInstallmentText;
    return `Simulação: 18x de R$ ${simulation.installment} pelo Mercado Pago. Total parcelado R$ ${simulation.total}. Valores sujeitos às condições e disponibilidade do cartão no checkout.`;
  };
  const renderInstallmentNote = (note, product, cashCents, quantity = 1) => {
    const text = installmentNoteText(product, cashCents, quantity);
    const boundary = text.indexOf(' Total parcelado ');
    if (!text.startsWith('Simulação:') || boundary < 0) { note.textContent = text; return; }
    const emphasis = node('strong', '', text.slice(0, boundary + 1));
    Object.assign(emphasis.style, {display: 'block', fontWeight: '700', fontSize: '1.05rem', lineHeight: '1.4', color: 'inherit'});
    const details = node('small', '', text.slice(boundary + 1));
    Object.assign(details.style, {display: 'block', marginTop: '.35rem', fontSize: '.85em', lineHeight: '1.5'});
    note.replaceChildren(emphasis, details);
  };
  const addInstallmentNote = (card, product) => {
    if (product.kind !== 'equipamento' || !visible(product)) return;
    const price = card.querySelector('.catalog-card-price');
    if (!price) return;
    let note = card.querySelector('[data-hsb-installments]');
    if (!note) {
      note = node('p', 'catalog-card-status muted');
      note.setAttribute('data-hsb-installments', '');
      price.insertAdjacentElement('afterend', note);
    }
    renderInstallmentNote(note, product, card.dataset.price ? Number(card.dataset.price) : null);
  };
  const makeCard = (product, live = null) => {
    const card = node('article', 'product-card catalog-card');
    card.dataset.handle = product.handle;
    card.dataset.productType = product.type || '';
    card.dataset.productTitle = product.title || '';
    card.dataset.searchText = normalize([product.title, product.type, product.summary, ...stringsOf(product.ingredients), ...stringsOf(product.facts)].join(' '));
    const reference = consultationOnly(product);
    const prices = reference ? variantsOf(product).map(variant => variant.price * 100).filter(Number.isFinite) : live ? [live.price_min ?? live.price].filter(Number.isFinite) : [];
    if ((!product.price_on_request || product.price_at_cash) && prices.length) card.dataset.price = String(Math.min(...prices));
    const media = link('', productUrl(product), 'product-media catalog-card-photo');
    media.setAttribute('aria-label', `Conhecer ${product.title}`);
    media.append(imageFor(product, 'catalog-card-image'));
    const body = node('div', 'product-card-content catalog-card-content');
    body.append(node('p', 'catalog-card-type', product.type || ''), node('h3', 'catalog-card-title'));
    body.lastElementChild.append(link(product.title, productUrl(product)));
    if (product.summary) body.append(node('p', 'catalog-card-summary', product.summary));
    const bottom = node('div', 'catalog-card-bottom');
    const labels = (reference ? variantsOf(product) : live?.variants || []).map(variant => variant.label || variant.title).filter(label => label && label !== 'Default Title');
    if (labels.length) bottom.append(node('p', 'catalog-card-options', [...new Set(labels)].join(' · ')));
    bottom.append(node('p', 'price catalog-card-price', reference ? referencePrice(product) : livePrice(product, live)));
    bottom.append(node('p', 'catalog-card-status muted', reference ? 'Disponibilidade sob consulta' : product.price_on_request ? product.price_at_cash ? 'Consulte a disponibilidade e as condições' : 'Consulte o preço e as condições' : live ? live.available ? 'Compra disponível na loja' : 'Indisponível para compra no momento' : 'Confira disponibilidade e prazo na página do produto'));
    bottom.append(link(reference ? 'Ver detalhes ↗' : 'Conhecer o produto ↗', productUrl(product), 'catalog-card-link'));
    body.append(bottom);
    card.append(media, body);
    addInstallmentNote(card, product);
    return card;
  };
  const enrichNativeCard = card => {
    const handle = card.dataset.handle || card.dataset.hsbHandle;
    const product = byHandle(handle);
    if (!product) return;
    addInstallmentNote(card, product);
    card.dataset.handle = handle;
    card.dataset.productType = product.type || card.dataset.productType || '';
    card.dataset.productTitle = product.title || card.dataset.productTitle || '';
    card.dataset.searchText = normalize([product.title, product.type, product.summary, ...stringsOf(product.ingredients), ...stringsOf(product.facts)].join(' '));
    if (product.summary && card.querySelector('.catalog-card-summary')) card.querySelector('.catalog-card-summary').textContent = product.summary;
    if (product.price_on_request && !product.price_at_cash) { card.dataset.price = ''; const price = card.querySelector('.catalog-card-price'); if (price) price.textContent = 'Preço sob consulta'; }
  };
  const renderGrid = async (container, handles) => {
    if (!(container instanceof Element)) return;
    const list = Array.isArray(handles) ? handles : String(handles || '').split(',');
    const selected = [...new Set(list.map(handle => String(handle).trim()).filter(Boolean))].map(byHandle).filter(visible);
    if (!selected.length) return;
    const existing = new Map([...container.children].map(card => [card.dataset.handle || card.dataset.hsbHandle, card]));
    container.setAttribute('aria-busy', 'true');
    const cards = await Promise.all(selected.map(async product => {
      const native = existing.get(product.handle);
      if (!consultationOnly(product) && native?.hasAttribute('data-hsb-native-card')) { enrichNativeCard(native); return native; }
      return makeCard(product, await loadLive(product));
    }));
    container.replaceChildren(...cards);
    container.removeAttribute('aria-busy');
  };
  window.HSBCatalog = {renderGrid, productUrl};
  const safeRich = (parent, html) => {
    const template = document.createElement('template');
    template.innerHTML = String(html || '');
    const forbidden = new Set(['SCRIPT','STYLE','IMG','VIDEO','AUDIO','PICTURE','SOURCE','IFRAME','OBJECT','EMBED','FORM','INPUT','BUTTON','META','LINK','SVG']);
    const allowed = new Set(['P','BR','UL','OL','LI','STRONG','EM','B','I','H3','H4','DIV','SPAN','TABLE','THEAD','TBODY','TR','TH','TD','A']);
    const copy = (source, target) => {
      for (const child of source.childNodes) {
        if (child.nodeType === Node.TEXT_NODE) { target.append(document.createTextNode(child.textContent)); continue; }
        if (child.nodeType !== Node.ELEMENT_NODE || forbidden.has(child.tagName)) continue;
        if (!allowed.has(child.tagName)) { copy(child, target); continue; }
        const result = document.createElement(child.tagName.toLowerCase());
        if (child.tagName === 'A') {
          const href = safeUrl(child.getAttribute('href'));
          if (href) {
            const url = new URL(href);
            const match = url.pathname.match(/^\/products\/([^/]+)/);
            const linked = match ? byHandle(decodeURIComponent(match[1])) : null;
            result.href = linked && visible(linked) ? productUrl(linked) : href;
            if (url.origin !== window.location.origin) { result.target = '_blank'; result.rel = 'noopener noreferrer'; }
          }
        }
        copy(child, result); target.append(result);
      }
    };
    copy(template.content, parent);
  };
  const addFacts = (body, product) => {
    const facts = stringsOf(product.facts);
    if (facts.length) {
      const details = node('details', 'catalog-accordion'); details.open = true;
      details.append(node('summary', '', 'Características'));
      const list = node('ul', 'catalog-facts'); facts.forEach(fact => list.append(node('li', '', fact)));
      details.append(list); body.prepend(details);
    }
    const ingredients = stringsOf(product.ingredients);
    if (ingredients.length) {
      const details = node('details', 'catalog-accordion');
      details.append(node('summary', '', 'Ingredientes em destaque'));
      const list = node('ul', 'catalog-ingredients'); ingredients.forEach(value => list.append(node('li', '', value)));
      details.append(list, node('p', 'catalog-ingredient-note muted', 'Ingredientes destacados na página do produto. Consulte o rótulo para a composição completa e as instruções de uso.'));
      body.prepend(details);
    }
  };
  const initNativeProduct = root => {
    const product = byHandle(root.dataset.productHandle);
    let native;
    try { native = JSON.parse(root.querySelector('[data-hsb-native-product]')?.textContent || '{}'); } catch { return; }
    const select = root.querySelector('[data-hsb-variant-select]');
    const add = root.querySelector('[data-hsb-add]');
    const update = () => {
      const id = select?.value || root.querySelector('input[name="id"]')?.value;
      const variant = native.variants?.find(item => String(item.id) === String(id));
      const simulationVariant = variant || (root.dataset.priceOnRequest === 'true' && native.variants?.length === 1 ? native.variants[0] : null);
      const installmentNote = root.querySelector('[data-hsb-product-installments]');
      if (installmentNote) renderInstallmentNote(installmentNote, product, simulationVariant?.price, Number(root.querySelector('input[name="quantity"]')?.value ?? 1));
      if (!variant || root.dataset.priceOnRequest === 'true') { if (add) add.disabled = true; return; }
      const price = root.querySelector('[data-hsb-live-price]'); if (price) price.textContent = product ? cashPriceLabel(product, money(variant.price)) : money(variant.price);
      const status = root.querySelector('[data-hsb-availability]');
      if (status) { status.textContent = variant.available ? 'Disponível para compra. Confirme o prazo no checkout.' : 'Esta opção está indisponível para compra no momento.'; status.classList.toggle('is-available', variant.available === true); }
      if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'Adicionar ao carrinho' : 'Indisponível no momento'; }
      const label = root.querySelector('[data-hsb-selected-label]'); if (label) label.textContent = variant.title === 'Default Title' ? '' : variant.title;
      const note = root.querySelector('[data-hsb-photo-note]');
      if (note && product?.image_note) note.textContent = `${product.image_note.replace(/[.]+$/, '')}.${variant.title && variant.title !== 'Default Title' ? ` Opção selecionada: ${variant.title}.` : ''}`;
    };
    select?.addEventListener('change', update);
    root.querySelector('input[name="quantity"]')?.addEventListener('input', update);
    root.querySelector('input[name="quantity"]')?.addEventListener('change', update);
    root.querySelector('form')?.addEventListener('submit', event => { if (add?.disabled || root.dataset.priceOnRequest === 'true') event.preventDefault(); });
    update();
    if (product) { addFacts(root.querySelector('[data-hsb-details-body]'), product); initRelated(root.querySelector('[data-hsb-related]'), product); }
  };
  const initRelated = (section, product) => {
    if (!section) return;
    const related = (Array.isArray(product.related_handles) ? product.related_handles : []).filter(handle => handle !== product.handle && visible(byHandle(handle))).slice(0, 3);
    if (related.length) { section.hidden = false; renderGrid(section.querySelector('[data-hsb-related-grid]'), related); }
  };
  const renderConsultProduct = container => {
    const product = byHandle(container.dataset.hsbConsultProduct);
    if (!visible(product) || !consultationOnly(product)) return;
    const equipmentTerms = product.kind === 'equipamento' ? container.querySelector('template[data-hsb-equipment-terms]')?.content.cloneNode(true) : null;
    const equipmentPayment = product.kind === 'equipamento' ? container.querySelector('template[data-hsb-equipment-payment]')?.content.cloneNode(true) : null;
    document.title = `${product.title} · Head Spa Brasil`;
    const bread = node('nav', 'breadcrumb'); bread.setAttribute('aria-label', 'Você está aqui');
    bread.append(link('Início', rootUrl), node('span', '', '/'), link('Equipamentos', route('collections/equipamentos')), node('span', '', '/'), node('span', '', product.title));
    const main = node('section', 'catalog-product-main hsb-consult-main');
    const heading = node('div', 'catalog-product-heading'); heading.append(node('p', 'eyebrow', product.type || 'Equipamento'), node('h1', '', product.title));
    const gallery = node('figure', 'catalog-product-gallery');
    const frame = node('div', 'catalog-product-photo'); frame.append(imageFor(product, 'catalog-product-image', true));
    const caption = node('figcaption', 'catalog-photo-note muted', product.image_note || 'Fotografia selecionada do equipamento.'); gallery.append(frame, caption);
    const panel = node('div', 'catalog-product-panel'); if (product.summary) panel.append(node('p', 'catalog-product-summary', product.summary));
    const variants = variantsOf(product); let selected = variants[0];
    const price = node('p', 'price catalog-product-price');
    if (variants.length > 1) {
      const label = node('label', 'catalog-control-label', 'Escolha a opção');
      const select = node('select', 'catalog-sort'); select.id = `hsb-consult-options-${product.handle}`; label.htmlFor = select.id;
      variants.forEach((variant, index) => { const option = node('option', '', variant.label || variant.title || 'Opção do catálogo'); option.value = String(index); select.append(option); });
      select.addEventListener('change', () => { selected = variants[Number(select.value)]; updatePrice(); });
      const controls = node('div', 'catalog-variant-controls'); controls.append(label, select); panel.append(controls);
    }
    const priceRow = node('div', 'catalog-product-price-row'), priceBlock = node('div');
    priceBlock.append(price, node('p', 'catalog-price-note muted', product.price_at_cash ? 'Preço à vista. Consulte a disponibilidade e as condições com a equipe.' : product.price_on_request ? 'Confirme o valor e as condições com a equipe.' : 'Preço de referência do catálogo. Confirme o valor e as condições com a equipe.')); priceRow.append(priceBlock); panel.append(priceRow);
    if (equipmentPayment) panel.append(equipmentPayment);
    panel.append(node('p', 'catalog-product-status', 'Disponibilidade sob consulta.'), link('Consultar com a equipe ↗', whatsapp(), 'btn catalog-buy-button'), node('p', 'catalog-action-note muted', 'Você será direcionado ao WhatsApp. Nenhuma mensagem é enviada automaticamente.'));
    const delivery = node('div', 'catalog-delivery');
    if (product.kind === 'equipamento') delivery.append(node('p', 'catalog-delivery-highlight', 'Frete grátis para todo o Brasil'), node('p', 'catalog-delivery-highlight', 'Formação Método HSB® inclusa'), node('p', 'catalog-delivery-note muted', 'Confirme o prazo de entrega e os requisitos de instalação com a equipe.'));
    panel.append(delivery);
    const updatePrice = () => {
      price.textContent = product.price_on_request && !product.price_at_cash ? 'Preço sob consulta' : typeof selected?.price === 'number' ? cashPriceLabel(product, referenceMoney(selected.price)) : 'Consulte o preço';
      const installmentNote = panel.querySelector('[data-hsb-product-installments]');
      if (installmentNote) renderInstallmentNote(installmentNote, product, typeof selected?.price === 'number' ? selected.price * 100 : null);
    };
    updatePrice(); main.append(heading, gallery, panel);
    const details = node('section', 'catalog-product-details');
    const detailsHeading = node('div', 'catalog-details-heading'); detailsHeading.append(node('p', 'eyebrow', 'O produto, de perto'), node('h2', '', 'Detalhes para a sua escolha.'));
    const detailsBody = node('div', 'catalog-details-body');
    if (product.description_html) { const detail = node('details', 'catalog-accordion'); detail.open = true; detail.append(node('summary', '', 'Apresentação e itens do equipamento')); const content = node('div', 'prose catalog-description'); safeRich(content, product.description_html); detail.append(content); detailsBody.append(detail); }
    addFacts(detailsBody, product);
    if (equipmentTerms) detailsBody.append(equipmentTerms);
    details.append(detailsHeading, detailsBody);
    const related = node('section', 'catalog-related'); related.hidden = true;
    const relatedHeading = node('div', 'section-heading catalog-related-heading'), relatedCopy = node('div'); relatedCopy.append(node('p', 'eyebrow', 'Para conhecer também'), node('h2', '', 'Outras escolhas para o seu espaço.')); relatedHeading.append(relatedCopy, node('p', 'muted', 'Produtos vendidos separadamente.'));
    const relatedGrid = node('div', 'card-grid catalog-grid'); relatedGrid.setAttribute('data-hsb-related-grid', ''); related.append(relatedHeading, relatedGrid);
    container.replaceChildren(bread, main); if (detailsBody.children.length) container.append(details); container.append(related); initRelated(related, product);
  };
  const initCollection = async section => {
    const grid = section.querySelector('[data-hsb-collection-grid]');
    if (!grid) return;
    for (const placeholder of grid.querySelectorAll('[data-hsb-consult-card]')) {
      const product = byHandle(placeholder.dataset.hsbConsultCard);
      if (visible(product) && consultationOnly(product)) placeholder.replaceWith(makeCard(product)); else placeholder.remove();
    }
    for (const card of grid.querySelectorAll('[data-handle]')) {
      const product = byHandle(card.dataset.handle);
      if (product && !visible(product)) card.remove(); else enrichNativeCard(card);
    }
    const cards = [...grid.querySelectorAll('.catalog-card')];
    const controlRoot = section.querySelector('[data-hsb-filterable]');
    if (!controlRoot || !cards.length) return;
    const controls = controlRoot.querySelector('[data-hsb-local-controls]'); controls.hidden = false;
    const typeGroup = controls.querySelector('[data-hsb-types]');
    const input = controls.querySelector('[data-hsb-local-query]'), sort = controls.querySelector('[data-hsb-local-sort]');
    const count = controlRoot.querySelector('[data-hsb-count]'), empty = controlRoot.querySelector('[data-hsb-filter-empty]');
    let type = 'all'; const types = [...new Set(cards.map(card => card.dataset.productType).filter(Boolean))], buttons = [];
    const render = () => {
      const query = normalize(input.value);
      const filtered = cards.filter(card => (type === 'all' || card.dataset.productType === type) && (!query || (card.dataset.searchText || normalize(card.textContent)).includes(query)));
      let ordered = filtered.slice();
      if (sort.value === 'name') ordered.sort((a, b) => a.dataset.productTitle.localeCompare(b.dataset.productTitle, 'pt-BR'));
      if (sort.value === 'price-asc' || sort.value === 'price-desc') ordered.sort((a, b) => { const pa = a.dataset.price ? Number(a.dataset.price) : null, pb = b.dataset.price ? Number(b.dataset.price) : null; if (pa === null) return pb === null ? 0 : 1; if (pb === null) return -1; return sort.value === 'price-asc' ? pa - pb : pb - pa; });
      cards.forEach(card => { card.hidden = !filtered.includes(card); }); ordered.forEach(card => grid.append(card));
      count.textContent = `${filtered.length} ${filtered.length === 1 ? 'produto' : 'produtos'}`; empty.hidden = filtered.length > 0;
      buttons.forEach(({button, value}) => button.setAttribute('aria-pressed', String(type === value)));
    };
    ['all', ...types].forEach(value => { const button = node('button', 'catalog-filter', value === 'all' ? 'Todos' : value); button.type = 'button'; button.setAttribute('aria-pressed', String(value === 'all')); button.addEventListener('click', () => { type = value; render(); }); buttons.push({button, value}); typeGroup.append(button); });
    input.addEventListener('input', render); sort.addEventListener('change', render); render();
  };
  const initSearch = container => {
    const query = normalize(container.dataset.query.replace(/\*/g, ' '));
    const matches = products.filter(product => visible(product) && consultationOnly(product) && query && normalize([product.title, product.summary, product.type, ...stringsOf(product.ingredients)].join(' ')).includes(query));
    if (matches.length) { container.hidden = false; container.querySelector('[data-hsb-search-consult-grid]').replaceChildren(...matches.map(product => makeCard(product))); const empty = document.querySelector('[data-hsb-search-empty]'); if (empty) empty.hidden = true; }
  };
  const initCompare = async section => {
    const tables = section.querySelector('[data-hsb-comparison-tables]'); if (!tables) return;
    const compare = async (title, handles) => {
      const selected = handles.map(byHandle).filter(visible);
      const live = await Promise.all(selected.map(loadLive));
      const heading = node('h2', '', title), scroller = node('div', 'compare-wrap'); scroller.tabIndex = 0; scroller.setAttribute('aria-label', `${title}, com rolagem horizontal no celular`);
      const table = node('table', 'compare-table'), top = node('tr'); const modelHeading = node('th', '', 'Modelo'); modelHeading.scope = 'col'; top.append(modelHeading);
      selected.forEach(product => { const th = node('th'); th.scope = 'col'; th.append(imageFor(product, ''), node('h3', '', product.title), link('Ver detalhes', productUrl(product), 'btn btn-outline')); top.append(th); });
      const thead = node('thead'); thead.append(top); const body = node('tbody');
      const rows = [
        ['Preço do modelo', (product, index) => consultationOnly(product) ? referencePrice(product) : livePrice(product, live[index])],
        ['Disponibilidade', (product, index) => consultationOnly(product) ? 'Sob consulta' : product.price_on_request ? 'Consulte as condições' : live[index] ? live[index].available ? 'Confira o prazo no checkout' : 'Indisponível no momento' : 'Confira na página do produto'],
        ['Categoria', product => product.type || 'Equipamento'],
        ['Opções cadastradas', (product, index) => (consultationOnly(product) ? variantsOf(product) : live[index]?.variants || []).map(variant => variant.label || variant.title).filter(label => label !== 'Default Title').join(' / ') || 'Confira a ficha do modelo'],
        ['Entrega', () => 'Frete grátis nacional'], ['Formação', () => 'Método HSB® inclusa'], ['Itens e medidas', () => 'Confira a ficha completa do modelo']
      ];
      rows.forEach(([label, value]) => { const row = node('tr'), th = node('th', '', label); th.scope = 'row'; row.append(th); selected.forEach((product, index) => row.append(node('td', '', value(product, index)))); body.append(row); });
      table.append(thead, body); scroller.append(table); return [heading, scroller];
    };
    const cubas = await compare('Cubas para o seu espaço', ['cuba-de-marmore-1','cuba-de-fibra','cuba-anatomica-de-fibra','cuba-de-marmore']);
    const macas = await compare('Conjuntos de maca com cuba', ['maca-completa-com-cuba-de-fibra','maca-completa-com-cuba-de-fibra-anatomica','maca-completa-com-cuba-de-marmore','maca-completa-com-cuba-de-marmore-translucida']);
    tables.replaceChildren(...cubas, ...macas, node('h2', '', 'Para ampliar a experiência: Spa dos Pés'));
    const spa = node('div', 'card-grid catalog-grid'); tables.append(spa); await renderGrid(spa, ['maca-spa-dos-pes-com-cuba-de-fibra-spa-do-pes']);
  };
  const init = () => {
    const once = (selector, initialize) => document.querySelectorAll(selector).forEach(element => { if (element.dataset.hsbCommerceReady === 'true') return; element.dataset.hsbCommerceReady = 'true'; initialize(element); });
    once('[data-hsb-products]', container => renderGrid(container, container.dataset.hsbProducts));
    once('[data-hsb-product-root]', initNativeProduct);
    once('[data-hsb-consult-product]', renderConsultProduct);
    once('[data-hsb-collection]', initCollection);
    once('[data-hsb-search-consult]', initSearch);
    once('[data-hsb-compare]', initCompare);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
  document.addEventListener('shopify:section:load', init);
})();

